import Dragger from "antd/es/upload/Dragger";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Checkbox } from "antd";
import Title from "antd/es/typography/Title";
import { useState } from "react";
import { stickers } from "../../api/Post";

const StickersResizer = () => {
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [resize, setResize] = useState(true);

  const upload = async () => {
    if (fileList.length <= 0) return;
    setUploading(true);

    const formData = new FormData();
    fileList.forEach((f) => {
      formData.append("stickers", f);
    });
    formData.append("resize", resize ? 1 : 0);
    const res = await stickers(formData);

    const blob = new Blob([res.data]);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = url;
    a.download = "filename.gzip";
    a.click();
    window.URL.revokeObjectURL(url);
    setUploading(false);
  };

  const onRemove = (file) => {
    const index = fileList.indexOf(file);
    const newFileList = fileList.slice();
    newFileList.splice(index, 1);
    setFileList(newFileList);
  };

  const beforeUpload = (file) => {
    setFileList([...fileList, file]);
    return false;
  };

  const onDrop = (e) => {
    const files = e.dataTransfer.files;
    setFileList([...fileList, ...Object.keys(files).map((k) => files[k])]);
  };

  return (
    <>
      <Title level={2}>Redimensionner et compresser des images</Title>
      <Dragger
        onDrop={onDrop}
        onRemove={onRemove}
        fileList={fileList}
        multiple
        beforeUpload={beforeUpload}
      >
        <p className="ant-upload-drag-icon">
          <UploadOutlined />
        </p>
        <Title level={4}>Clique ou drop les images ici</Title>
        <p className="ant-upload-text">Maximum 100 Mo au total</p>
      </Dragger>
      <br />
      <Checkbox checked={resize} onChange={(e) => setResize(e.target.checked)}>
        Redimensionner
      </Checkbox>
      <br />
      <br />
      <Button disabled={uploading} type="primary" onClick={upload}>
        Enregistrer
      </Button>
    </>
  );
};

export default StickersResizer;
